import request from '@/utils/request'

// 查询收益
export function getIncomeByTime(params) {
  // let currentUrl = ``;
  // if (params.type === 'day') {
  //   currentUrl = `/dashboard/income/listByTime?startTime=${params.startTime}&endTime=${params.endTime}&stationId=${params.stationId}&type=${params.type}`
  // } else {
  //   currentUrl = `/dashboard/income/listByTime?stationId=${params.stationId}&type=${params.type}`
  // }
  return request({
    url: '/dashboard/income/listByTime',
    method: 'GET',
    params: params,
  })
}
// 查询统计信息
export function getIncomeTotal(stationId, startTime, endTime) {
  return request({
    url: `/dashboard/income/queryCensus`,
    method: 'GET',
    params: {
      stationId,
      startTime,
      endTime
    }
  })
}
/** 修改收益电价 */
export function modifyHistoryIncome(params) {
  return request({
    url: `/dashboard/income/modifyIncome`,
    method: 'PUT',
    data: params
  })
}

/** 导出 */
export function exportIncome(params) {
  return request({
    url: `/dashboard/income/export?startTime=${params.startTime}&endTime=${params.endTime}&stationId=${params.stationId}`,
    method: 'GET',
  })
}
